import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, AuthService, WebsocketService, WebsocketState } from '../services';
import { MatDialog } from '@angular/material/dialog';
import { routerTransition } from '../router.animations';
import { Subscription } from 'rxjs';
import { SerialPrinterService } from '../printer/printer.service';


@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css'],
  animations: [routerTransition()]
})
export class MainNavComponent implements OnInit, OnDestroy {

  toolbarVisible = false;
  isIconSidenav = false;
  sidenavChangeType = false;
  sideNavChangePosition: 'start' | 'end' = 'start';
  sidenavWidth = 250;
  oldRoute = '/';

  @ViewChild('drawer', { static: true }) sidenav: MatSidenav;

  WebsocketStateEnum = WebsocketState;

  public date: Date = new Date();

  private subs = new Subscription();

  private sidanavInit = false;

  private zoomValue = 100;
  public wsState: WebsocketState = WebsocketState.disconnected;
  public printerState: string = '';

  constructor(public router: Router,
    private route: ActivatedRoute,
    // public windowService: WindowService,
    public userService: UserService,
    public wsService: WebsocketService,
    // private themeService: ThemeService,
    // private typoService: TypographyService,
    // private configService: ConfigGeneralService,
    public authService: AuthService,
    // public printerService: SerialPrinterService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef) {

    setInterval(() => {
      this.date = new Date();
    }, 10000);

    this.subs.add(this.wsService.stateChanged.subscribe(
      (data) => { this.wsState = data; },
      (error) => { this.wsState = WebsocketState.disconnected; },
      () => { this.wsState = WebsocketState.disconnected; }
    ))

    // this.subs.add(this.printerService.getStateUntilConnected().subscribe(
    //   (data) => { this.printerState = data },
    //   (error) => {},
    //   () => {}
    // ))

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  sidenavChanged() {
    if (!this.sidenav.opened) {
      if (this.sidenavChangeType) {
        this.sidenavChangeType = false;
        this.isIconSidenav = !this.isIconSidenav;
        this.sidenav.open();
      } else if (this.sideNavChangePosition !== this.sidenav.position) {
        this.sidenav.position = this.sideNavChangePosition;
        this.sidenav.open();
      }
    }
  }

  animationData() {
    const r = this.route.root.firstChild;
    if (r != null) {
      if (r.children.length === 1) { // only level 1 routes
        this.oldRoute = this.router.url;
        // console.log(this.oldRoute);
      }
    }
    const val = {
      value: this.oldRoute,
      params: {
        inWidth: document.getElementById('nav-content').offsetWidth + 'px',
        inHeight: document.getElementById('nav-content').offsetHeight + 'px',
        outWidth: document.getElementById('nav-content').offsetWidth + 'px'
      }
    };
    // console.log(val);
    return val;
  }

}
